// extracted by mini-css-extract-plugin
export default {"locationId":"index_locationId_LE_yu"};